import { workspaceActionTypes } from './workspace.types';

// INIT
export const workspaceInitRequest = () => ({
    type: workspaceActionTypes.WORKSPACE_INIT_REQUEST,
});
export const workspaceInitSuccess = ({ list, currentWorkspace, plan, restrictions }) => ({
    type: workspaceActionTypes.WORKSPACE_INIT_SUCCESS,
    payload: { list, currentWorkspace, plan, restrictions },
});
export const workspaceInitFailure = (error) => ({
    type: workspaceActionTypes.WORKSPACE_INIT_FAILURE,
    payload: error,
});

// SWITCH WORKSPACE
export const workspaceSwitchRequest = (workspaceId) => ({
    type: workspaceActionTypes.WORKSPACE_SWITCH_REQUEST,
    payload: workspaceId,
});
export const workspaceSwitchSuccess = ({ currentWorkspace, plan, restrictions }) => ({
    type: workspaceActionTypes.WORKSPACE_SWITCH_SUCCESS,
    payload: { currentWorkspace, plan, restrictions },
});

// FETCH TEAMS
export const workspaceFetchTeamsRequest = (workspaceId) => ({
    type: workspaceActionTypes.WORKSPACE_FETCH_TEAMS_REQUEST,
    payload: workspaceId,
});
export const workspaceFetchTeamsSuccess = (teams) => ({
    type: workspaceActionTypes.WORKSPACE_FETCH_TEAMS_SUCCESS,
    payload: teams,
});
export const workspaceFetchTeamsFailure = (error) => ({
    type: workspaceActionTypes.WORKSPACE_FETCH_TEAMS_FAILURE,
    payload: error,
});

// FETCH MEMBERS
export const workspaceFetchMembersRequest = (workspaceId) => ({
    type: workspaceActionTypes.WORKSPACE_FETCH_MEMBERS_REQUEST,
    payload: workspaceId,
});
export const workspaceFetchMembersSuccess = (members) => ({
    type: workspaceActionTypes.WORKSPACE_FETCH_MEMBERS_SUCCESS,
    payload: members,
});
export const workspaceFetchMembersFailure = (error) => ({
    type: workspaceActionTypes.WORKSPACE_FETCH_MEMBERS_FAILURE,
    payload: error,
});

// RESET
export const workspaceReset = () => ({
    type: workspaceActionTypes.WORKSPACE_RESET,
});
